import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { mobileUtil } from '@panda/tool';
import { getAdapterRedirectRoute, setCookie } from '@/util/route';
import Home from '../views/Home.vue';
import appHelper from './appHelper';
import go from './go';
import market from './market';
import trade from './trade';
import course from './course';
import privacy from './privacy';
import admin from './admin';

// https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
type RawLocation = string | Location;
const originalPush = VueRouter.prototype.push;
// @ts-ignore
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  // @ts-ignore
  return originalPush.call(this, location).catch((err: Error) => {
    if (VueRouter.isNavigationFailure(err)) {
      // resolve err
      return err;
    }
    // rethrow error
    return Promise.reject(err);
  });
};

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: Home,
    name: 'Home',
    meta: {
      title: '熊猫未来学院',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
  },
  {
    path: '/acl',
    name: 'AccountCancellation',
    component: () => import(/* webpackChunkName: "acl" */ '../views/AccountCancellation.vue'),
    meta: {
      title: '帐号注销',
      needLogin: true,
    },
  },
  ...appHelper,
  ...market,
  ...trade,
  ...course,
  ...go,
  ...privacy,
  ...admin,
  {
    path: '/*',
    name: 'Default',
    component: Home,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

const gaMap = new Map();
gaMap.set('Trade.MyOrder.Mobile', { category: '我的订单页', action: '页面访问' });
gaMap.set('Trade.Pay.Mobile', { category: '确认订单页', action: '页面访问' });
gaMap.set('Trade.Success.Mobile', { category: '参加成功页', action: '页面访问' });
gaMap.set('Trade.OrderDetail.Mobile', { category: '订单详情页', action: '页面访问' });
gaMap.set('Trade.MyCoupon.Mobile', { category: '我的优惠券页', action: '页面访问' });
gaMap.set('Trade.CouponDetail.Mobile', { category: '优惠券领取页', action: '页面访问' });
// gaMap.set('AboutCoding', { category: '围棋介绍静态页', action: '页面访问' });
// gaMap.set('AboutGo', { category: '编程介绍静态页', action: '页面访问' });
gaMap.set('Course.Detail', { category: 'steam课程详情页页面访问', action: '页面访问' });
gaMap.set('Course.FreedomVideo', { category: 'Ai视频播放页', action: '页面访问' });

router.beforeEach((to, from, next) => {
  // 记录项目第一次进入的页面的地址，用于微信分享
  const authUrl = `${window.location.origin}${to.fullPath}`;
  if (!window.ENTRY_URL) {
    window.ENTRY_URL = authUrl; // 将后面的参数去除
  }

  const { params, query } = to;
  const myself = to.matched[to.matched.length - 1];
  const parent = to.matched[to.matched.length - 2];
  let adapterRedirectRoute = null;

  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }

  // 自动写入cookie
  if (to.query && to.query['Set-Cookie']) {
    const cookie = `${to.query['Set-Cookie']}`;
    setCookie(cookie);
  }

  // 统一加地址栏参数（meta有query时）（前面不允许调用next()，否则app会因为重定向闪屏）
  const defaultQuery = to.meta?.query;
  if (defaultQuery
    && Object.keys(defaultQuery).length > 0
    && Object.keys(defaultQuery).filter((key) => !Object.keys(to.query).includes(key)).length > 0// to.query不包含to.meta.query
  ) {
    // 解决ios不能识别next的地址栏变化，所以用href来触发
    // if (mobileUtil.isIPhone() || mobileUtil.isIPad()) {
    const routerData = router.resolve({
      path: to.path,
      params: to.params,
      query: { ...defaultQuery, ...to.query },
    });
    window.location.href = routerData.href;
    return;
    // }
    // router.replace({
    //   path: to.path,
    //   params: to.params,
    //   query: { ...defaultQuery, ...to.query },
    // });
    // next();
    // return;
  }

  // 是否需要重定向到父路径：在父路径需要自适应、不是从父路径重定向过来的路径，需要重新进入父路径进行自适应
  const isNeedAdapt = !parent?.meta.adapterRules || params.isRedirect;
  if (isNeedAdapt) {
    adapterRedirectRoute = getAdapterRedirectRoute(myself, routes, params, query);
    if (adapterRedirectRoute) {
      router.replace(adapterRedirectRoute);
      next();
      return;
    }
  }

  next();
});

export default router;
